// import Serializer from "./serializer";
import AxiosConfig from '../api/axios.config';
const Mustache = require('mustache');
import axios, { AxiosInstance } from 'axios';

let alertsBannerTemplate = require('../../templates/components/alerts/alert-banner').default;
let pageBannerTemplate = require('../../templates/components/alerts/alert-page-level-banner').default;
class Alerts {
    axiosClient: AxiosInstance;

    constructor() {
        this.axiosClient = axios.create(AxiosConfig);
        this.init();
    }

    init() {
        const infoBanner : HTMLElement = document.querySelector('.alert-banner-bar.info');
        const alertToggle = document.querySelector('.alert-toggle-wrap');
        let closeBtn;
        
        if(infoBanner != null){
            closeBtn = infoBanner.querySelector('.btn-close');
            alertToggle.classList.remove('d-none');

            //hide info banner if close button has been clicked before, reset after a week
            if(localStorage.getItem('alertClosed') === 'true'){
                const now = new Date();
                let aWeekLater : Date = new Date();
                aWeekLater.setDate(now.getDate() + 7);
                let storedAlertTime = localStorage.getItem('alertClosedDate');
                if(storedAlertTime != null){
                    if(Date.parse(storedAlertTime) < aWeekLater.getTime()){
                        closeBtn.click();
                    } else {
                        localStorage.removeItem('alertClosed');
                        localStorage.removeItem('alertClosedDate')
                    }
                }
            }

            if(closeBtn != null){
                closeBtn.addEventListener('click', function(){
                    localStorage.setItem('alertClosed', 'true');
                    localStorage.setItem('alertClosedDate', Date());
                })
            }
        }
        
        // TODO: change link to prod domain - make a global config for axios
        this.axiosClient.get(`api/alerts/banner`)
        .then(function (response) {
            let alertBannerTemplateRendered = "";
            if (response.data) {
                let data = response.data;
                if (data) {
                    if (data.alerts) {
                        let header = document.querySelector(".main-header");
                        //let alertBanner = data.alerts.alertBanner;
                        let globalAlert = data.alerts.globalAlert;
                        let siteAlerts = data.alerts.siteAlerts;
                        console.log(data.alerts);
                        if (globalAlert.active == "yes") {
                            alertBannerTemplateRendered = Mustache.render(alertsBannerTemplate, globalAlert);
                            if (header) {
                                let doc = new DOMParser().parseFromString(alertBannerTemplateRendered, "text/html");
                                console.log(doc);
                                console.log("global doc^");
                                let alertDOM = doc.querySelector('div');
                                console.log(alertDOM);
                                console.log("alert dom ^");
                                header.insertBefore(alertDOM, header.firstChild);
                            }
                        }
                        if(siteAlerts)
                        {
                            console.log("here site alerts");
                            let alertPageBannerTemplateRendered = "";
                            let pageHeader = document.querySelector("main.page-content");
                            siteAlerts.forEach(alert => {
                                if(alert.siteUrl){
                                    let currentUrl = window.location.href.split('?')[0];
                                    console.log("alert url");
                                    alertPageBannerTemplateRendered = Mustache.render(pageBannerTemplate, alert);
                                    if(pageHeader){
                                        let urlPath = new URL(alert.siteUrl).pathname;
                                        let currUrlPath = new URL(currentUrl).pathname;
                                            console.log(currentUrl);
                                            console.log(currUrlPath);
                                            console.log("alert site children");
                                            console.log(urlPath);
                                            if(currUrlPath == urlPath){
                                                console.log("it's equal");
                                                let doc = new DOMParser().parseFromString(alertPageBannerTemplateRendered, "text/html");
                                                console.log(doc);
                                                let alertDOM = doc.querySelector('div');
                                                console.log(alertDOM);
                                                pageHeader.insertBefore(alertDOM, pageHeader.firstChild);
                                            }
                                            else{
                                                if(alert.children == "yes")
                                                {
                                                    if(currentUrl.includes(urlPath)){
                                                        let doc = new DOMParser().parseFromString(alertPageBannerTemplateRendered, "text/html");
                                                        let alertDOM = doc.querySelector('div');
                                                        pageHeader.insertBefore(alertDOM, pageHeader.firstChild);
                                                    }
                                                }
                                            }
                                        
                                    }
                                }
                            });
                        
                        }
                    }
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });

        
    }
}

export default Alerts;